import { useCallback, useId } from 'react'
import { Link } from 'react-router-dom'
import { leerClienteRecordado } from '../clienteActivo'
import { useAyuda } from './ContextoDeAyuda'
import { useCierreConEscape } from './cierreConEscape'
import { novedadesPendientes, recorridoEnCurso, rutaDeNovedad } from './seleccionDeTips'
import './tips.css'

/**
 * RF-1706 · Lo nuevo de cada despliegue, la primera vez que el usuario entra después. Una a la vez, de la más vieja
 * a la más nueva, en un aviso NO modal. Al cerrarla o al seguir su enlace queda vista y no vuelve.
 *
 * No sale a quien se dio de alta después de la novedad, ni mientras corre el recorrido guiado, ni con «Mostrar
 * TIPs» apagado.
 */
export function Novedades() {
  const ayuda = useAyuda()
  const idTitulo = useId()

  const novedad = ayuda.mostrarTips && !recorridoEnCurso(ayuda) ? (novedadesPendientes(ayuda)[0] ?? null) : null

  const { marcarNovedad } = ayuda
  const clave = novedad?.clave
  const marcar = useCallback(() => { if (clave) marcarNovedad(clave) }, [clave, marcarNovedad])
  useCierreConEscape(novedad !== null, marcar)

  if (!novedad) return null

  return (
    <aside className="tip-flotante tip-novedad" aria-labelledby={idTitulo}>
      <div className="tip-cuerpo">
        <span className="tip-etiqueta">Novedad</span>
        <strong id={idTitulo} className="tip-titulo">{novedad.titulo}</strong>
        <p className="tip-texto">{novedad.texto}</p>
        {novedad.ruta && novedad.enlace && (
          <Link className="tip-enlace" to={rutaDeNovedad(novedad.ruta, leerClienteRecordado())} onClick={marcar}>
            {novedad.enlace}
          </Link>
        )}
      </div>
      <button type="button" className="enlace tip-cerrar" onClick={marcar} aria-label={`Cerrar la novedad «${novedad.titulo}»`}>
        Cerrar
      </button>
    </aside>
  )
}
